import clsx from "clsx";

import colors from "colors";

import "./styles.scss";

export interface AvatarProps {
	rounded?: boolean;
	bgColor?: string;
	borderColor?: string;
	borderStyle?: "solid" | "dashed" | "dotted" | "none";
	borderWidth?: number;
	size?: "sm" | "md" | "lg" | "xl";
	children: React.ReactNode;
	cssClass?: string;
	id?: string;
}

export default function Avatar({
	rounded = true,
	bgColor = colors.neutral["high-pure-50"],
	borderColor = colors.neutral["low-pure-500"],
	borderStyle = "solid",
	borderWidth = 2.5, // valor em px
	size = "md",
	children,
	id,
	cssClass = ""
}: Readonly<AvatarProps>) {
	return (
		<div
			className={clsx(`avatar outline-neutral-low-pure-500`, {
				"avatar-rounded": rounded,
				"avatar-squared": !rounded,
				"avatar-4": size === "sm",
				"avatar-6": size === "md",
				"avatar-10": size === "lg",
				"avatar-14": size === "xl",
				[cssClass]: !!cssClass
			})}
			style={{
				backgroundColor: bgColor,
				borderStyle,
				borderColor,
				borderWidth: `${borderWidth / 16}rem`
			}}
			id={id}
		>
			{children}
		</div>
	);
}
